const adminMenu = {
  groups: [
    {
      id: 'dashboard',
      label: 'Shisha',
      items: [
        { to: '/admin/hookah-flavors', label: 'Hookah Flavors', adminOnly: true },
        { to: '/admin/bar-tables', label: 'Tables', staff: true },
        { to: '/admin/hookah-inventory', label: 'Inventory' },
        { to: '/admin/flavour-deliveries', label: 'Flavour Deliveries', adminOnly: true },
        { to: '/admin/inventory-snapshot', label: 'Revision Snapshot', adminOnly: true },
        { to: '/admin/inventory-history', label: 'Inventory History', adminOnly: true },
        { to: '/admin/brands', label: 'Brands' },
        { to: '/admin/inactive-flavours-request', label: 'Inactive Flavours Request' },
        { to: '/admin/statistics/disabled-flavours', label: 'Disabled Flavour Statistics', adminOnly: true },
      ]
    },
    {
      id: 'access',
      label: 'Access',
      items: [
        { to: '/admin/users', label: 'Users' },
        { to: '/admin/public-user/preview', label: 'Public User Preview', staff: true },
        { to: '/admin/roles', label: 'Roles' },
        { to: '/admin/settings/feature-flags', label: 'Feature Flags', adminOnly: true },
        { to: '/admin/application-logs', label: 'Application Logs', adminOnly: true }
      ]
    },
    {
      id: 'loyalty',
      label: 'Loyalty Program',
      items: [
        { to: '/admin/loyalty-profiles', label: 'Loyalty Profiles', adminOnly: true },
        { to: '/admin/daily-hookah-logs', label: 'Daily Hookah Logs', adminOnly: true },
        { to: '/admin/failed-hookah-logs', label: 'Failed Hookah Logs', adminOnly: true },
        { to: '/admin/loyalty-reservations', label: 'Table Reservations', staff: true, featureFlag: 'enable_loyalty_user_reservations' },
        { to: '/admin/scan-qr', label: 'Scan Loyalty QR', staff: true },
        { to: '/admin/mobile-notifications', label: 'Mobile Notifications', adminOnly: true },
        { to: '/admin/shop-management', label: 'Shop Management', adminOnly: true },
        { to: '/admin/hookah-types', label: 'Hookah Types', adminOnly: true }
      ]
    },
    {
      id: 'catalog',
      label: 'Products Catalog',
      items: [

        { to: '/admin/categories', label: 'Product Categories' },
        { to: '/admin/drinks', label: 'Drinks', adminOnly: true },
        { to: '/admin/menu-clicks', label: 'Menu clicks', adminOnly: true },
        { to: '/admin/drink-price-history', label: 'Drinks price history', adminOnly: true }
      ]
    }
    ,
    {
      id: 'promoting',
      label: 'Promoting',
      items: [
        { to: '/admin/promotions', label: 'Promotions' }
      ]
    }
    ,
    {
      id: 'accounting',
      label: 'Accounting',
      items: [
        { to: '/admin/accounting/transactions', label: 'Transactions', adminOnly: true },
        { to: '/admin/accounting/categories', label: 'Categories', adminOnly: true },
        { to: '/admin/accounting/hookahs-per-day', label: 'Hookahs per day', adminOnly: true },
        { to: '/admin/accounting/reports', label: 'Reports', adminOnly: true },
        { to: '/admin/cash-bank-transfers', label: 'Cash ↔ Bank Transfers', adminOnly: true }
      ]
    },
    {
      id: 'reports',
      label: 'Reports',
      items: [
        { to: '/admin/trigger-reports', label: 'Trigger Reports', adminOnly: true },
        { to: '/admin/monthly-balances', label: 'Monthly Balances', adminOnly: true },
        { to: '/admin/monthly-payments', label: 'Monthly Payments', adminOnly: true }
      ]
    }
  ]
};

export default adminMenu;
